// @flow
import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';
import FullButton from './FullButton';
import theme from '../../../theme-config';

class TertiaryFullButton extends PureComponent<Props> {
  render() {
    const styles = getStyles();
    const { style, ...others } = this.props;
    return (
      <FullButton
        {...others}
        style={[styles.container, style, styles.tertiaryFullButton]}
        textStyle={[styles.text, this.props.textStyle]}
      />
    );
  }
}

type Props = {
  text: string,
  style?: any,
  disabled?: boolean,
  isLoading?: boolean,
  emphasizeSubText?: boolean,
  textStyle?: any,
  onPress?: ?Function,
  onLongPress?: ?Function,
  testID?: string,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      height: 37,
      alignItems: 'center',
      justifyContent: 'center',
    },
    text: {
      fontSize: 16,
      color: theme.buttons.TERTIARY.textColor,
      fontWeight: '500',
    },
    tertiaryFullButton: {
      backgroundColor: theme.buttons.TERTIARY.backgroundColor,
      borderColor: theme.buttons.TERTIARY.borderColor,
      borderWidth: 1,
    },
  });

export default TertiaryFullButton;
